import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import required modules
import { Navigation } from "swiper";

// Import Swiper styles
import "swiper/css";

function TestPage() {
  return (
    <div>
      <h1 className="flex justify-center items-center text-6xl p-10">
        This is a Test Page
      </h1>

      <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
        <SwiperSlide className="text-4xl">Slide 1</SwiperSlide>
        <SwiperSlide className="text-4xl">Slide 2</SwiperSlide>
        <SwiperSlide className="text-4xl">Slide 3</SwiperSlide>
        <SwiperSlide className="text-4xl">Slide 4</SwiperSlide>
        <SwiperSlide className="text-4xl">Slide 5</SwiperSlide>
        <SwiperSlide className="text-4xl">Slide 6</SwiperSlide>
        <SwiperSlide className="text-4xl">Slide 7</SwiperSlide>
        <SwiperSlide className="text-4xl">Slide 8</SwiperSlide>
        <SwiperSlide className="text-4xl">Slide 9</SwiperSlide>
      </Swiper>
    </div>
  );
}

export default TestPage;
